import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, router } from '@inertiajs/react';
import { Card, Button } from '../../components/ui';
import Input, { InputLabel, InputGroup } from '../../components/ui/Input';
import Logo from '../../components/ui/Logo';
import ThemeToggle from '../../components/ui/ThemeToggle';

export default function StudentJoin({ code: initialCode, error }) {
  const { t } = useTranslation();
  const [code, setCode] = useState(initialCode || '');
  const [name, setName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    router.post('/join', { code, name }, {
      onFinish: () => setIsSubmitting(false),
    });
  };

  const handleCodeChange = (e) => {
    // Uppercase and limit to 6 characters
    const value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 6);
    setCode(value);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-950 flex items-center justify-center p-4">
      <div className="absolute top-4 right-4">
        <ThemeToggle />
      </div>
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link href="/" className="inline-block no-underline">
            <Logo className="h-8" />
          </Link>
          <p className="mt-2 text-gray-600 dark:text-gray-400">{t('join.joinLesson')}</p>
        </div>

        <Card className="p-8">
          <form onSubmit={handleSubmit} className="space-y-6">
            {error && (
              <div className="p-4 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg">
                <p className="text-sm text-red-600 dark:text-red-400">{error}</p>
              </div>
            )}

            <InputGroup>
              <InputLabel htmlFor="code" required>{t('join.joinCode')}</InputLabel>
              <Input
                id="code"
                type="text"
                value={code}
                onChange={handleCodeChange}
                placeholder={t('join.joinCodePlaceholder')}
                className="text-center text-2xl font-mono tracking-widest"
                maxLength={6}
                autoComplete="off"
                autoFocus
                required
              />
              <p className="text-xs text-gray-500 dark:text-gray-400 mt-1 text-center">
                {t('join.joinCodeHelp')}
              </p>
            </InputGroup>

            <InputGroup>
              <InputLabel htmlFor="name">{t('join.yourName')}</InputLabel>
              <Input
                id="name"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder={t('join.namePlaceholder')}
                autoComplete="name"
              />
            </InputGroup>

            <Button
              type="submit"
              variant="primary"
              size="lg"
              className="w-full"
              disabled={isSubmitting || code.length !== 6}
            >
              {isSubmitting ? t('join.joining') : t('join.joinSession')}
            </Button>
          </form>
        </Card>

        <div className="mt-6 text-center">
          <p className="text-sm text-gray-500 dark:text-gray-400">
            {t('join.areYouTeacher')}{' '}
            <Link
              href="/login"
              className="font-medium text-gray-700 dark:text-gray-300 hover:underline"
            >
              {t('auth.signInHere')}
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
